import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-search-filter-form]';
const PLUGIN_NAME = 'SearchFilterForm';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--search-filter-form" */ './search-filter-form'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/search-filter-form/index.js